import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const AdminLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async () => {
    setError('');
    setLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/auth/login`,
        { id: username, password },
        { withCredentials: true } // Important for setting the HttpOnly cookie
      );

      if (response.data.accessToken) {
        // Store access token in memory or localStorage (for now localStorage is easier for persistence across refreshes, 
        // though memory is more secure. Given the current setup, let's use localStorage to keep it simple for the user)
        localStorage.setItem('accessToken', response.data.accessToken);
        navigate('/dashboard');
      } else {
        setError('Login failed. Please check your credentials.');
      }
    } catch (err) {
      console.error('Login error:', err);
      setError('Invalid username or password!');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-[#c5baaa]">
      <div className="w-full max-w-md p-8 bg-[#2c2c2c] rounded-2xl shadow-lg">
        <h2 className="text-2xl font-bold text-center text-[#ee7828] mb-6">Admin Login</h2>

        {error && (
          <div className="bg-red-500 text-white p-3 rounded mb-4 text-center">
            {error}
          </div>
        )}

        <div className="mb-4">
          <label className="block text-[#806d61] mb-2" htmlFor="username">
            Username
          </label>
          <input
            type="text"
            id="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="w-full px-4 py-2 border rounded-lg bg-[#c5baaa] text-[#2c2c2c] focus:outline-none focus:ring-2 focus:ring-[#ee7828]"
            placeholder="Enter your username"
          />
        </div>
        <div className="mb-6">
          <label className="block text-[#806d61] mb-2" htmlFor="password">
            Password
          </label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full px-4 py-2 border rounded-lg bg-[#c5baaa] text-[#2c2c2c] focus:outline-none focus:ring-2 focus:ring-[#ee7828]"
            placeholder="Enter your password"
          />
        </div>
        <button
          onClick={handleLogin}
          disabled={loading}
          className={`w-full py-2 px-4 bg-[#ee7828] text-white rounded-lg hover:bg-[#d46922] transition duration-300 ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
        >
          {loading ? 'Logging in...' : 'Login'}
        </button>
      </div>
    </div>
  );
};

export default AdminLogin;
